module.exports = __webpack_public_path__ + "img/img2.88f5c4f3.png";